<template>
    <svg
        alt="YouTube"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M19.821 9.3s-.147-1.094-.631-1.588c-.6-.642-1.283-.642-1.599-.684-2.24-.168-5.586-.168-5.586-.168h-.01s-3.366 0-5.586.168c-.316.042-1.01.053-1.61.684-.473.494-.63 1.588-.63 1.588S4 10.594 4 11.9v1.21c0 1.293.168 2.577.168 2.577s.148 1.094.631 1.588c.6.642 1.41.62 1.768.684 1.283.126 5.438.168 5.438.168s3.366 0 5.586-.168c.316-.042 1-.042 1.599-.684.473-.494.631-1.588.631-1.588S20 14.402 20 13.108v-1.21c0-1.293-.168-2.598-.168-2.598h-.01Zm-9.478 5.27V10.08l4.324 2.251-4.324 2.24Z" fill="currentColor"/>
    </svg>
</template>
